import React, { useState } from 'react';
import { supabase } from '../../lib/supabase';
import KeepsakeItem from './KeepsakeItem';

export default function KeepsakeList({ characterId, keepsakes, onRefresh }) {
  const [adding, setAdding] = useState(false);
  const [newName, setNewName] = useState('');
  const [newDesc, setNewDesc] = useState('');
  const [saving, setSaving] = useState(false);

  const items = keepsakes.filter(k => k.character_id === characterId);

  const handleAdd = async () => {
    if (!newName.trim()) return;
    setSaving(true);
    await supabase.from('keepsakes').insert([{
      character_id: characterId,
      name: newName.trim(),
      description: newDesc.trim(),
    }]);
    setNewName('');
    setNewDesc('');
    setSaving(false);
    setAdding(false);
    onRefresh?.();
  };

  return (
    <div className="mt-4 pt-4 border-t border-dashed border-parchment-dark">
      <div className="font-lora text-[0.82rem] text-ink-light tracking-wider uppercase mb-2">
        Keepsakes & Inventory
      </div>

      {items.length === 0 && !adding && (
        <div className="font-lora text-[0.78rem] italic text-ink-light mb-2">Nothing carried yet.</div>
      )}

      <div className="space-y-0">
        {items.map(item => (
          <KeepsakeItem key={item.id} item={item} onRefresh={onRefresh} />
        ))}
      </div>

      {adding ? (
        <div className="mt-3 bg-parchment/70 border border-parchment-dark rounded p-3 space-y-2">
          <input
            autoFocus
            className="form-input-styled text-[0.82rem] py-1.5 font-medium"
            value={newName}
            onChange={e => setNewName(e.target.value)}
            placeholder="Item name"
          />
          <textarea
            className="form-input-styled text-[0.82rem] py-1.5 min-h-[70px] resize-y leading-relaxed"
            value={newDesc}
            onChange={e => setNewDesc(e.target.value)}
            placeholder="A note about this keepsake..."
          />
          <div className="flex gap-2 justify-end pt-1">
            <button 
              onClick={() => { setAdding(false); setNewName(''); setNewDesc(''); }} 
              className="font-lora text-[0.76rem] text-ink-mid hover:text-ink transition-colors"
            >
              cancel
            </button>
            <button 
              onClick={handleAdd} 
              disabled={saving || !newName.trim()}
              className="bg-ink text-parchment rounded px-3 py-1 font-lora text-[0.76rem] hover:bg-ink-mid disabled:opacity-50 transition-colors"
            >
              {saving ? 'adding…' : '+ add'}
            </button>
          </div>
        </div>
      ) : (
        <button 
          onClick={() => setAdding(true)} 
          className="mt-2 w-full text-left font-lora text-[0.78rem] italic text-ink-light hover:text-ink transition-colors border border-dashed border-parchment-dark rounded px-3 py-2 hover:bg-parchment-dark/10"
        >
          + add keepsake
        </button>
      )}
    </div>
  );
}